import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { FamilyModel } from "../../brothers-attribution/brother-attribution-models/family-model";
import { BrotherAttributionModalType } from "../../brothers-attribution/brother-attribution-models/brother-attribution-modal-type";

@Component({
  selector: "user-management-upload-users-excel-modal",
  templateUrl: "./user-management-upload-users-excel-modal.component.html",
  styleUrls: ["./user-management-upload-users-excel-modal.component.scss"],
})
export class UserManagementUploadUsersExcelModalComponent implements OnInit {
  public static readonly modalOptions: NgbModalOptions = {
    backdropClass: "create-event-backdropClass",
    backdrop: true,
    windowClass: "brother-attribution-window-class",
  };
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public family: FamilyModel;
  public readonly BrotherAttributionModalType = BrotherAttributionModalType;
  public _brotherAttributionModalType: BrotherAttributionModalType;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this._brotherAttributionModalType =
      this._brotherAttributionModalType ||
      BrotherAttributionModalType.createNewFamilyConnection;
  }

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  public modalActionsHandler($event: any) {
    if ($event === "close") {
      this.modalClose(null);
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-upload-users-excel-modal/user-management-upload-users-excel-modal.component.ts